<template>
    <div>
        <v-card-title>
            Facebook
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="campaigns"
            :search="search"
            class="elevation-1">
            <template v-slot:[`item.Revenue`]='prop'>
                <v-edit-dialog
                    :return-value.sync="prop.item.Revenue"
                    large
                    @save="save(prop.item)"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                >
                    {{ prop.item.Revenue }}
                    <template v-slot:input>
                        <v-text-field
                            v-model="prop.item.Revenue"
                            label="Edit"
                            single-line
                            autofocus
                        ></v-text-field>
                    </template>
                </v-edit-dialog>
            </template>
        </v-data-table>
        <v-snackbar
            v-model="snack"
            :timeout="3000"
            :color="snackColor"
            >
            {{ snackText }}

            <template v-slot:action="{ attrs }">
                <v-btn
                v-bind="attrs"
                text
                @click="snack = false"
                >
                Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>


<script>

export default {
    props: {
        inputtedDate: {type: Object},
        channel: {type: String}
    },
    beforeMount() {
        this.getFacebook();
    },
    watch: {
        inputtedDate: function() {
            this.getFacebook();
        }
    },
    data: () => ({
        campaigns: [
            {
                "Date": '',
                "Campaign": '',
                "Cost": '',
                "Revenue": ''
            }
        ],
        snack: false,
        snackColor: '',
        snackText: '', 
        search: '',
    }),
    methods: {
        getFacebook: function() {
            if (this.$props.inputtedDate.startDate && this.$props.inputtedDate.endDate) {
                const url = 'https://dxo2z89hkb.execute-api.us-east-2.amazonaws.com/prod/getfacebookdata';
                const data = {
                    'startDate': this.$props.inputtedDate.startDate,
                    'endDate': this.$props.inputtedDate.endDate,
                    'channel': this.$props.channel
                }
                const request = {
                    method: 'POST',
                    Headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify(data)
                };
                fetch(url, request).then((response) => {
                    return response.json();
                }).then((data) => {
                    // turn the data back into an object since it
                    for (let items in data) {
                        data[items].Date = data[items].Date.toString().split('T')[0]
                    }
                    this.campaigns = data;
                });
            }
        },
        save (item) {
            this.snack = true
            this.snackColor = 'success'
            this.snackText = 'Data saved'
            this.updateCampaign(item.Revenue, item.Date, item.Campaign);
        },
        cancel () {
            this.snack = true
            this.snackColor = 'error'
            this.snackText = 'Canceled'
        },
        open () {
            this.snack = true
            this.snackColor = 'info'
            this.snackText = 'Dialog opened'
        },
        close () {
            console.log('Dialog closed')
        },
        updateCampaign: function(rev, date, campaign) {
            const url = 'https://dxo2z89hkb.execute-api.us-east-2.amazonaws.com/prod/updatefacebookdata';
            const data = {
                'Revenue': rev,
                'Date': date,
                'Campaign': campaign,
                'Channel': this.$props.channel
            }
            const request = {
                method: 'PUT',
                Headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify(data)
            };
            fetch(url, request).then((response) => {
                return response.json();
            }).then((data) => {
                console.log(data)
            });
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: 'Date',
                    value: 'Date'
                },
                {
                    text: 'Campaign',
                    value: 'Campaign'
                },
                {
                    text: 'Revenue',
                    value:'Revenue'
                },
                {
                    text: 'Cost',
                    value: 'Cost'
                }
            ]
        }
    }
}
</script>